const cartMaxItems = 10;

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    window.addRecommendation();
    window.addFunctionButtonCartCollection();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

/**
 * Atualiza a quantidade de um item no carrinho, aplicando o limite de 10 itens por produto.
 * * @param {string} line - A chave da linha do item no carrinho (ex: '1', '2', etc.).
 * @param {number|string} quantity - A nova quantidade desejada.
 * @param {string} name - Nome do produto (mantido por compatibilidade de assinatura).
 * @param {number|string} variantId - ID da variante.
 */
async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const newQuantity = parseInt(quantity, 10);
    const cartItem = document.querySelector(`#CartDrawer-Item-${line}`);
    const quantityInput = document.getElementById(`Drawer-quantity-${line}`) || document.getElementById(`Quantity-${line}`);

    // --- 1. CHAMADA ÚNICA DE DADOS (Máxima Performance) ---
    let cart;
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        if (!response.ok) throw new Error('Falha ao carregar o carrinho.');
        cart = await response.json();
    } catch (error) {
        console.error('Erro ao carregar dados do carrinho:', error);
        this.disableLoading(line);
        return; 
    }
    
    // --- 2. LÓGICA DE REMOÇÃO DE KITS ---
    const kitName = cartItem ? cartItem.getAttribute('data-kit-name') : null;

    if (kitName) {
        // Lógica de Kit: prepara a remoção de todos os itens do kit
        const updates = cart.items.map((item, index) => {
            const itemLine = index + 1;
            // Acessa o atributo de kitName do item no DOM (necessário para kits)
            const itemKitName = document.querySelector(`#CartDrawer-Item-${itemLine}`)?.getAttribute('data-kit-name');
            
            // Se o item pertence ao kit que está sendo modificado/removido, zera a quantidade
            if (itemKitName === kitName) {
                return 0;
            }
            return item.quantity;
        });

        try {
            // Envia o array 'updates' com as quantidades para remoção do kit
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            });
            console.log('Kit modificado/removido e carrinho atualizado.');
            location.reload();
        } catch (error) {
            console.error('Erro ao atualizar o carrinho (Kit):', error);
        }
        return; // Finaliza a execução após a lógica de Kit
    }

    // --- 3. LÓGICA DE LIMITE POR PRODUTO (10 ITENS) ---
    
    // Se não há input, ou não há product ID, ou o limite é por variante, prossegue sem checagem de limite por produto
    const limiteCompra = quantityInput ? quantityInput.getAttribute('data-limite-compra') : null;
    const productId = quantityInput ? quantityInput.getAttribute('data-product-id') : null;
    const isVariantLimit = limiteCompra === 'variant';

    if (!isVariantLimit && productId) {
        let totalInCart = 0;
        let quantidadeAtualDaLinha = 0;

        // Itera sobre os itens do carrinho (variável 'cart' já carregada)
        cart.items.forEach(item => {
            // Soma o total de todas as variantes do PRODUTO
            if (String(item.product_id) === String(productId)) {
                totalInCart += item.quantity;
            }
            // Isola a quantidade ATUAL da VARIANTE que está sendo modificada
            if (String(item.variant_id) === String(variantId)) {
                quantidadeAtualDaLinha = item.quantity;
            }
        });

        // Calcula a nova soma: Total Antigo - Quantidade Atual Desta Linha + Nova Quantidade Desejada
        const newTotal = totalInCart - quantidadeAtualDaLinha + newQuantity;

        if (newTotal > cartMaxItems) {
            // Bloqueia a atualização
            if (quantityInput) {
                quantityInput.value = quantityInput.getAttribute('value');
            }
            this.updateLiveRegions(line, `Limite de ${cartMaxItems} itens por produto excedido.`);
            this.disableLoading(line);
            return;
        }
    }
    
    // --- 4. CONTINUAR ATUALIZAÇÃO ---
    // Se não for um Kit, ou se passou pela checagem de limite de 10 por produto, continua.
    this._continueUpdateQuantity(line, quantity, name, variantId);
}

  // Nova função para continuar o fluxo normal
  _continueUpdateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    if (quantity > cartMaxItems) {
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');
      quantityElement.value = quantityElement.getAttribute('value');
      this.updateLiveRegions(line, "Limite de " + cartMaxItems + " itens no carrinho");
      this.disableLoading(line)
      return
    } else {
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch(() => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
          window.addRecommendation();
          window.addFunctionButtonCartCollection();
        });
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
      if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = '';
    }, 2000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
